// import anime from 'animejs'
// import axios from 'axios'

import cardTpl from './cards-templates/edit-orga'

export default {
  name: 'edit-orga',

  ui: {
    btAdd: '[js-bt-add]',
  },

  events: [
    {
      target: 'btAdd',
      on: 'click',
      handle () {
        /* const li = document.createElement('li')
        li.innerHTML += cardTpl()
        this.list.append(li) */
        const div = document.createElement('div')
        div.innerHTML = cardTpl({
          id: Date.now(),
          position: this.list.querySelectorAll('.card').length + 1,
        })
        this.list.append(div.querySelector('.card'))

        // this.list.innerHTML += cardTpl({id: Date.now(),position: this.list.querySelectorAll('.card').length + 1})

        // this.list.innerHTML += `<li>${cardTpl()}</li>`
      },
    },
  ],

  componentDidMount () {
    this.list = this.el.querySelector('.cards-list')
  },
}
